import { GetServerSidePropsContext, NextPage } from "next";

import ProjectList from "@domains/project/views/ProjectList/ProjectList";
import getTokenServerSession from "@domains/auth/utils/getTokenServerSession";

const ProjectListPage: NextPage = () => {
  return (
    <div>
      <ProjectList />
    </div>
  );
};

export default ProjectListPage;

export function getServerSideProps(context: GetServerSidePropsContext) {
  const tokenSession = getTokenServerSession({
    req: context.req,
    res: context.res,
    query: context.query,
  });

  return {
    ...(context.query.access && {
      redirect: {
        destination: tokenSession?.redirectUrl,
      },
    }),
    props: {},
  };
}
